<div class="d-flex text-center justify-content-around loader-container">
  <img width="100" src="assets/images/common/hubloader.gif" alt="Cargando..." />
  <h5 class="text-gray-n4" *ngIf="text">{{ text || "" }}...</h5>
</div>
